export const enum EventStatus {
  Published = 'published',
  NotPublished = 'notPublished',
  Finished = 'finished',
  Preview = 'preview',
}
